module.exports = __webpack_public_path__ + "img/logo-teamtip.310dca18.svg";